<template>
    <div id="MutLibGeneSearch-div">
        <div>
            <h2 style="text-align: center;padding-top: 20px;font-size: 30px;color: #407338">Mutation Library</h2>
        </div>
        <div class="region_select1">
            <div style="margin-right: 30px;margin-top: 8px; float: left; width: 100px; text-align: right">
                <a style="font-size: 20px; color: #407338; font-weight: bold">Base on</a>
            </div>
            <el-radio-group v-model="radio" style="float: left; width: 650px;">
                <el-radio :label="1" border><i>A. thaliana</i></el-radio>
                <el-radio :label="4" border><i>B. rapa</i></el-radio>
                <el-radio :label="2" border>Gene</el-radio>
                <el-radio :label="3" border>Accessions</el-radio>
            </el-radio-group>
        </div>
        <div class="mutation_type_select1">
            <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">Select all</el-checkbox>
            <div style="margin: 5px; 0;"></div>
            <el-checkbox-group v-model="checkedMutationTypes" @change="handleCheckedMutationTypesChange">
                <el-checkbox style="font-size: 24px" v-for="mutationType in mutationTypes" :label="mutationType" :key="mutationType">{{mutationType}}</el-checkbox>
            </el-checkbox-group> -->
            <el-transfer
                v-model="checkedMutationTypes"
                :props="{key:'text', label:'introduction'}"
                :data="mutationTypes"
                :titles="['To be selected', 'To be retrieved']"
                :button-texts="['REMOVE', 'ADD']"
                @mouseover.native="addTitle"
                target-order="push"
            >
            </el-transfer>
        </div>
        <div class="information_input">
            <div v-if="this.radio == 1">
                <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 5px" label-width="130px">
                    <el-form-item label="GeneID">
                        <el-input style="width: 160px" v-model="AthGene" :disabled="isAthGene"></el-input>
                    </el-form-item>

                    <el-form-item label="Description">
                        <el-input style="width: 160px" v-model="description" :disabled="isDescription"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" style="width: 120px; margin-left: 60px" @click="example_help">Help</el-button>
                    </el-form-item>
                </el-form>

                <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="130px">
                    <el-form-item style="text-align: left" label="Example">
                        <el-button v-if="isAthGene" type="primary" style="width: 160px;" @click="example8" disabled>AT4G23980</el-button>
                        <el-button v-else type="primary" style="width: 160px;" @click="example8">AT4G23980</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button v-if="isDescription" type="primary" style="width: 160px; margin-left: 130px" @click="example123" disabled>FLC</el-button>
                        <el-button v-else type="primary" style="width: 160px; margin-left: 130px" @click="example123">FLC</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" style="width: 120px; margin-left: 60px" @click="searchMutLib">SUBMIT</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else-if="this.radio == 2">
                <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 5px" label-width="80px">
                    <el-form-item label="Gene">
                        <el-input style="width: 170px" v-model="gene1" placeholder="Gene"></el-input>
                    </el-form-item>

                    <el-form-item style="text-align: left" label="Example">
                        <el-button type="primary" style="width: 200px" @click="example456">A01p14320.1_BraCCA</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" style="width: 80px; margin-left: 40px" @click="example_help">Help</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primaey" style="width: 100px; margin-left: 40px" @click="searchMutLib">SUBMIT</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else-if="this.radio == 3">
                <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="100px">
                    <el-form-item style="text-align: left" label="Accession">
                        <el-input style="width: 140px" v-model="accession1" placeholder="accession"></el-input>
                    </el-form-item>

                    <el-form-item style="text-align: left" label="Example">
                        <el-button type="primary" style="width: 140px" @click="example7">20S0128</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" style="width: 80px; margin-left: 60px" @click="example_help">Help</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primaey" style="width: 100px; margin-left: 60px" @click="searchMutLib">SUBMIT</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else-if="this.radio == 4">
                <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="90px">
                    <el-form-item style="text-align: left" label="GeneID">
                        <el-input style="width: 180px" v-model="BrapaGene"></el-input>
                    </el-form-item>

                    <el-form-item style="text-align: left" label="Example">
                        <el-button type="primary" style="width: 180px" @click="example9">BraA07g002670.3C</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" style="width: 80px; margin-left: 30px" @click="example_help">Help</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primaey" style="width: 100px; margin-left: 30px" @click="searchMutLib">SUBMIT</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div style="height: 450px; width: 1140px; margin: -10px auto auto auto;" v-if="show_result1">
            <hr class="hr1">
            <div class="show_result1" v-if="show_result1">
                <div style="width: 150px; margin-left: 0px; margin-bottom: 5px; float: left;"><h2 style="color: #275015">Accessions</h2></div>
                <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; float: right;">
                    <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportAccessionsExcel">Download</el-button>
                </div>
                <el-table
                    id="accessionsShow"
                    :data="accessionsList"
                    border
                    height="300px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center">
                    <!-- <el-table-column prop="geneID" label="Gene" width="180px"></el-table-column> -->
                    <el-table-column prop="accession" label="Accession" width="120px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleAccession(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.accession}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mutation_type" label="Mutation type" width="200px"></el-table-column>
                </el-table>
            </div>
            <div class="show_result2" v-if="show_result2">
                <div style="width: 150px; margin-left: 0px; margin-bottom: 5px; float: left;"><h2 style="color: #275015">Mutations</h2></div>
                <div style="width: 150px; margin-left: 0px; margin-bottom: 0px; float: left;">
                    <el-button style="font-weight: bold;" @click="OpenJBrowse">JBrowse</el-button>
                </div>
                <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; float: right;">
                    <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportMutationsExcel">Download</el-button>
                </div>
                <el-table
                    id="mutationsShow"
                    :data="mutationsList"
                    border
                    height="300px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center">
                    <!-- <el-table-column prop="gene" label="Gene" width="180px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleAccession(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.gene}}</el-button>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="chromosome" label="Chromosome" width="150px"></el-table-column>
                    <el-table-column prop="position" label="Position" width="100px"></el-table-column>
                    <el-table-column prop="reference" label="Ref" width="50px"></el-table-column>
                    <el-table-column prop="alter" label="Alt" width="50px"></el-table-column>
                    <el-table-column prop="mutation_type" label="Mutation type" width="280px"></el-table-column>
                    <el-table-column prop="putative" label="Putative" width="120px"></el-table-column>
                </el-table>
            </div>
        </div>
        <div style="height: 450px; width: 1140px; margin: -10px auto auto auto;" v-if="show_result3">
            <hr class="hr1">
            <div style="width: 150px; margin-left: 0px; margin-bottom: 5px; float: left;"><h2 style="color: #275015">Mutations</h2></div>
            <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; float: right;">
                <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportAccessionMutationsExcel">Download</el-button>
            </div>
            <div class="show_result3">
                <el-table
                    id="accessionMutationShow"
                    :data="accessionMutationList"
                    border
                    height="300px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center">
                    <el-table-column prop="gene" label="Gene" width="203px">
                        <!-- <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleAccession(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.gene}}</el-button>
                        </template> -->
                    </el-table-column>
                    <el-table-column prop="chromosome" label="Chromosome" width="180px"></el-table-column>
                    <el-table-column prop="position" label="Position" width="120px"></el-table-column>
                    <el-table-column prop="reference" label="Ref" width="85px"></el-table-column>
                    <el-table-column prop="alter" label="Alt" width="85px"></el-table-column>
                    <el-table-column prop="mutation_type" label="Mutation type" width="300px"></el-table-column>
                    <el-table-column prop="putative" label="Putative" width="150px"></el-table-column>
                </el-table>
            </div>
        </div>
        <div style="height: 900px; width: 1140px; margin: -10px auto auto auto;" v-if="show_result4">
            <hr class="hr1">
            <div style="width: 800px; margin-left: 0px; margin-bottom: 5px; float: left;">
                <h2 style="color: #275015">BLASTX (best hit) of genes to <i>A. thaliana</i></h2>
                <a style="color: #275015; font-weight: bold"><i>A. thaliana</i> genes followed by "s" indicate syntenic genes</a>
            </div>
            <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; margin-top: 10px; float: right;">
                <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportAthGeneExcel">Download</el-button>
            </div>
            <div class="show_result4">
                <el-table
                    id="AthGeneShow"
                    :data="AthGeneList"
                    border
                    height="360px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center">
                    <el-table-column prop="geneID" label="geneID" width="180px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleGeneID(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.geneID}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="AthGeneID" label="A. thaliana geneID" width="180px"></el-table-column>
                    <el-table-column prop="other_name" label="other name" width="240px"></el-table-column>
                    <el-table-column prop="description" label="description" width="480px"></el-table-column>
                </el-table>
            </div>
            <div class="show_result5" v-if="show_result5">
                <div style="width: 150px; margin-left: 0px; margin-bottom: 5px; float: left;"><h2 style="color: #275015">Accessions</h2></div>
                <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; float: right;">
                    <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportAccessionsExcel1">Download</el-button>
                </div>
                <el-table
                    id="accessionsShow1"
                    :data="accessionsList1"
                    border
                    height="300px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center">
                    <!-- <el-table-column prop="geneID" label="Gene" width="180px"></el-table-column> -->
                    <el-table-column prop="accession" label="Accession" width="120px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleAccession1(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.accession}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mutation_type" label="Mutation type" width="200px"></el-table-column>
                </el-table>
            </div>
            <div class="show_result2" v-if="show_result6">
                <div style="width: 150px; margin-left: 0px; margin-bottom: 5px; float: left;"><h2 style="color: #275015">Mutations</h2></div>
                <div style="width: 150px; margin-left: 0px; margin-bottom: 0px; float: left;">
                    <el-button style="font-weight: bold;" @click="OpenJBrowse">JBrowse</el-button>
                </div>
                <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; float: right;">
                    <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportMutationsExcel1">Download</el-button>
                </div>
                <el-table
                    id="mutationsShow1"
                    :data="mutationsList1"
                    border
                    height="300px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center">
                    <!-- <el-table-column prop="gene" label="Gene" width="180px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleAccession(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.gene}}</el-button>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="chromosome" label="Chromosome" width="150px"></el-table-column>
                    <el-table-column prop="position" label="Position" width="100px"></el-table-column>
                    <el-table-column prop="reference" label="Ref" width="50px"></el-table-column>
                    <el-table-column prop="alter" label="Alt" width="50px"></el-table-column>
                    <el-table-column prop="mutation_type" label="Mutation type" width="280px"></el-table-column>
                    <el-table-column prop="putative" label="Putative" width="120px"></el-table-column>
                </el-table>
            </div>
        </div>
        <div style="height: 1300px; width: 1140px; margin: -10px auto auto auto;" v-if="show_result7">
            <hr class="hr1">
            <div style="width: 800px; margin-left: 0px; margin-bottom: 5px; float: left;">
                <h2 style="color: #275015">Syntenic genes to <i>B. rapa</i></h2>
            </div>
            <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; margin-top: 10px; float: right;">
                <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportBrapaGeneExcel">Download</el-button>
            </div>
            <div class="show_result7">
                <el-table
                    id="BrapaGeneShow"
                    :data="BrapaGeneList"
                    border
                    height="700px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center"
                    :row-class-name="tableRowClassName">
                    <el-table-column prop="geneID" label="geneID" width="227px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleGeneID1(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.geneID}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Brapa15" label="Brara_Chiifu_V1.5" width="228px"></el-table-column>
                    <el-table-column prop="Brapa30" label="Brara_Chiifu_V3.0" width="228px"></el-table-column>
                    <el-table-column prop="Brapa31" label="Brara_Chiifu_V3.1" width="228px"></el-table-column>
                    <el-table-column prop="Brapa35" label="Brara_Chiifu_V3.5" width="228px"></el-table-column>

                </el-table>
            </div>
            <div class="show_result5" v-if="show_result8">
                <div style="width: 150px; margin-left: 0px; margin-bottom: 5px; float: left;"><h2 style="color: #275015">Accessions</h2></div>
                <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; float: right;">
                    <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportAccessionsExcel2">Download</el-button>
                </div>
                <el-table
                    id="accessionsShow2"
                    :data="accessionsList2"
                    border
                    height="300px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center">
                    <!-- <el-table-column prop="geneID" label="Gene" width="180px"></el-table-column> -->
                    <el-table-column prop="accession" label="Accession" width="120px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleAccession2(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.accession}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mutation_type" label="Mutation type" width="200px"></el-table-column>
                </el-table>
            </div>
            <div class="show_result2" v-if="show_result9">
                <div style="width: 150px; margin-left: 0px; margin-bottom: 5px; float: left;"><h2 style="color: #275015">Mutations</h2></div>
                <div style="width: 150px; margin-left: 0px; margin-bottom: 0px; float: left;">
                    <el-button style="font-weight: bold;" @click="OpenJBrowse">JBrowse</el-button>
                </div>
                <div style="width: 150px; margin-right: 0px; margin-bottom: 0px; float: right;">
                    <el-button style="font-weight: bold; margin-right: 0px; float: right;" @click="exportMutationsExcel2">Download</el-button>
                </div>
                <el-table
                    id="mutationsShow2"
                    :data="mutationsList2"
                    border
                    height="300px"
                    line-height="10px"
                    header-cell-style="color: #407338; text-align: center"
                    :row-style="{height: '35px'}"
                    cell-style="color: #407338; text-align: center">
                    <!-- <el-table-column prop="gene" label="Gene" width="180px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleAccession(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.gene}}</el-button>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="chromosome" label="Chromosome" width="150px"></el-table-column>
                    <el-table-column prop="position" label="Position" width="100px"></el-table-column>
                    <el-table-column prop="reference" label="Ref" width="50px"></el-table-column>
                    <el-table-column prop="alter" label="Alt" width="50px"></el-table-column>
                    <el-table-column prop="mutation_type" label="Mutation type" width="280px"></el-table-column>
                    <el-table-column prop="putative" label="Putative" width="120px"></el-table-column>
                </el-table>
            </div>
        </div>
        <div id="waiting" v-if="isWaiting">
            <img src="../assets/img/waiting.gif" style="height: 200px;width: 200px">
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import FileSaver from 'file-saver';
    import XLSX from 'xlsx';
    import {scrollAnimation} from '../assets/js/scrollPos';
    const mutationTypeoptions = [
        {'text': 'downstream_gene_variant', 'introduction': 'downstream_gene_variant'}, 
        {'text': 'initiator_codon_variant', 'introduction': 'initiator_codon_variant'},
        {'text': 'intergenic_region', 'introduction': 'intergenic_region'}, 
        {'text': 'intron_variant', 'introduction': 'intron_variant'}, 
        {'text': 'missense_variant', 'introduction': 'missense_variant'}, 
        {'text': 'missense_variant&splice_region_variant', 'introduction': 'missense_variant&splice_region_variant'}, 
        {'text': 'splice_acceptor_variant&intron_variant', 'introduction': 'splice_acceptor_variant&intron_variant'}, 
        {'text': 'splice_donor_variant&intron_variant', 'introduction': 'splice_donor_variant&intron_variant'}, 
        {'text': 'splice_region_variant&intron_variant', 'introduction': 'splice_region_variant&intron_variant'},
        {'text': 'splice_region_variant&stop_retained_variant', 'introduction': 'splice_region_variant&stop_retained_variant'}, 
        {'text': 'splice_region_variant&synonymous_varian', 'introduction': 'splice_region_variant&synonymous_varian'},
        {'text': 'start_lost', 'introduction': 'start_lost'}, 
        {'text': 'start_lost&splice_region_variant', 'introduction': 'start_lost&splice_region_variant'}, 
        {'text': 'stop_gained', 'introduction': 'stop_gained'}, 
        {'text': 'stop_gained&splice_region_variant', 'introduction': 'stop_gained&splice_region_variant'},
        {'text': 'stop_lost', 'introduction': 'stop_lost'}, 
        {'text': 'stop_lost&splice_region_variant', 'introduction': 'stop_lost&splice_region_variant'}, 
        {'text': 'stop_retained_variant', 'introduction': 'stop_retained_variant'}, 
        {'text': 'synonymous_variant', 'introduction': 'synonymous_variant'}, 
        {'text': 'upstream_gene_variant', 'introduction': 'upstream_gene_variant'}
    ]
    export default {
        name: 'MutLibGeneSearch',
        data () {
            return {
                radio: 4,
                gene1: '',
                gene1Upstream: 0,
                gene1Downstream: 0,
                description: '',
                showFlanking: 0,
                mutationTypes: mutationTypeoptions,
                checkedMutationTypes: ['stop_gained', 'missense_variant'],
                accessionsList: [],
                accessionsList1: [],
                accessionsList2: [],
                mutationsList: [],
                mutationsList1: [],
                mutationsList2: [],
                isWaiting: 0,
                show_result2: 0,
                show_result1: 0,
                accession1: '',
                show_result3: 0,
                accessionMutationList: [],
                AthGene: '',
                isAthGene: false,
                isDescription: false,
                show_result4: 0,
                AthGeneList: [],
                show_result5: 0,
                show_result6: 0,
                BrapaGene: '',
                show_result7: 0,
                BrapaGeneList: [],
                show_result8: 0,
                show_result9: 0,
            }
        },
        mounted() {

        },
        methods: {
            number() {
                if (this.gene1Upstream > 5) {
                    alert('Limit inpu size to 5kb!')
                    this.gene1Upstream = 5
                }
                if (this.gene1Downstream > 5) {
                    alert('Limit input size to 5kb!')
                    this.gene1Downstream = 5
                }
                this.gene1Upstream=this.gene1Upstream.replace(/[^.\d]/g,'');
                this.gene1Upstream=this.gene1Upstream.replace('.','');
                this.gene1Downstream=this.gene1Downstream.replace(/[^.\d]/g,'');
                this.gene1Downstream=this.gene1Downstream.replace('.','');
            },
            addTitle(e) {
                let target_el = e.target;
                if (target_el.title) return;
                target_el.title = target_el.innerText;
            },
            example123() {
                this.description = 'FLC';
                this.searchMutLib();
            },
            example456() {
                this.gene1 = 'A01p14320.1_BraCCA';
                this.searchMutLib();
            },
            example7() {
                this.accession1 = '20S0128';
                this.searchMutLib();
            },
            example8() {
                this.AthGene = 'AT4G23980';
                this.searchMutLib();
            },
            example9() {
                this.BrapaGene = 'BraA07g002670.3C';
                this.searchMutLib();
            },
            OpenJBrowse() {
                var gene1 = this.gene1;
                axios({
                    url: 'http://39.100.233.196:8001/api/search_B9008_JBrowseInfo/',
                    type: 'json',
                    params: {
                        gene1
                    },
                    method: 'get',
                }).then((res)=>{
                    window.open('http://39.100.233.196:83/jbrowse/?data=CCA&loc=' + res.data[0].chromosome + '%3A' +
                    res.data[0].startPos + '..' + res.data[0].endPos + '&tracks=DNA%2CCCA&highlight=');
                })
            },
            handleAccession(row) {
                this.isWaiting = 1;
                this.show_result2 = 0;
                var accession = row.accession;
                var geneID = row.geneID;
                var mutation_type = row.mutation_type;
                axios({
                    url: 'http://39.100.233.196:8001/api/search_B9008_MutLibExtractInfo/',
                    type: 'json',
                    params: {
                        accession,
                        geneID,
                        mutation_type
                    },
                    method: 'get',
                }).then((res)=>{
                    // console.log(res.data)
                    this.mutationsList = res.data
                    this.isWaiting = 0;
                    this.show_result2 = 1;
                })
            },
            handleAccession1(row) {
                this.isWaiting = 1;
                this.show_result6 = 0;
                var accession = row.accession;
                var geneID = row.geneID;
                var mutation_type = row.mutation_type;
                axios({
                    url: 'http://39.100.233.196:8001/api/search_B9008_MutLibExtractInfo/',
                    type: 'json',
                    params: {
                        accession,
                        geneID,
                        mutation_type
                    },
                    method: 'get',
                }).then((res)=>{
                    // console.log(res.data)
                    this.mutationsList1 = res.data
                    this.isWaiting = 0;
                    this.show_result6 = 1;
                })
            },
            handleAccession2(row) {
                this.isWaiting = 1;
                this.show_result9 = 0;
                var accession = row.accession;
                var geneID = row.geneID;
                var mutation_type = row.mutation_type;
                axios({
                    url: 'http://39.100.233.196:8001/api/search_B9008_MutLibExtractInfo/',
                    type: 'json',
                    params: {
                        accession,
                        geneID,
                        mutation_type
                    },
                    method: 'get',
                }).then((res)=>{
                    console.log(res.data)
                    this.mutationsList2 = res.data
                    this.isWaiting = 0;
                    this.show_result9 = 1;
                })
            },
            handleGeneID(row) {
                this.isWaiting = 1;
                this.show_result5 = 0;
                this.show_result6 = 0;
                this.gene1 = row.geneID;
                var gene1 = row.geneID;
                var checkedMutationTypes2 = this.checkedMutationTypes;
                var checkedMutationTypesStr = checkedMutationTypes2.join(';')
                if (gene1 != '') {
                    axios({
                        url: 'http://39.100.233.196:8001/api/search_B9008_MutLibGene/',
                        type: 'json',
                        params: {
                            gene1,
                            checkedMutationTypesStr,
                        },
                        method: 'get',
                    }).then((res)=>{
                        console.log(res.data)
                        this.accessionsList1 = res.data;
                        this.show_result5 = 1;
                        this.isWaiting = 0;
                        const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                        scrollAnimation(currentY, 800)
                    })
                } else {
                    alert('Please input Gene!')
                }
            },
            handleGeneID1(row) {
                this.isWaiting = 1;
                this.show_result8 = 0;
                this.show_result9 = 0;
                this.gene1 = row.geneID;
                var gene1 = row.geneID;
                var checkedMutationTypes3 = this.checkedMutationTypes;
                var checkedMutationTypesStr = checkedMutationTypes3.join(';')
                if (gene1 != '') {
                    axios({
                        url: 'http://39.100.233.196:8001/api/search_B9008_MutLibGene/',
                        type: 'json',
                        params: {
                            gene1,
                            checkedMutationTypesStr,
                        },
                        method: 'get',
                    }).then((res)=>{
                        console.log(res.data);
                        this.accessionsList2 = res.data;
                        this.show_result8 = 1;
                        this.isWaiting = 0;
                        const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                        scrollAnimation(currentY, 1000)
                    })
                }
            },
            searchMutLib() {
                this.show_result1 = 0;
                this.show_result2 = 0;
                this.show_result3 = 0;
                this.show_result4 = 0;
                this.show_result5 = 0;
                this.show_result6 = 0;
                this.show_result7 = 0;
                this.show_result8 = 0;
                this.show_result9 = 0;
                this.isWaiting = 1
                if (this.gene1Upstream == '') {
                    this.gene1Upstream = 0
                }
                if (this.gene1Downstream == '') {
                    this.gene1Downstream = 0
                }
                
                if (this.radio == 1) {
                    // console.log('OKOKOOK')
                    var description = this.description;
                    var AthGene = this.AthGene;
                    axios({
                        url: 'http://39.100.233.196:8001/api/search_B9008_MutLibAthDescription/',
                        type: 'json',
                        params: {
                            description,
                            AthGene
                        },
                        method: 'get',
                    }).then((res)=>{
                        // console.log(res.data)
                        this.AthGeneList = res.data
                        this.show_result4 = 1
                        this.isWaiting = 0
                        const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                        scrollAnimation(currentY, 400)
                    })
                } else if (this.radio == 2) {
                    // console.log(this.checkedMutationTypes)
                    var gene1 = this.gene1;
                    // console.log(gene1)
                    var checkedMutationTypes = this.checkedMutationTypes;
                    var checkedMutationTypesStr = checkedMutationTypes.join(';')
                    if (this.gene1 != '') {
                        axios({
                            url: 'http://39.100.233.196:8001/api/search_B9008_MutLibGene/',
                            type: 'json',
                            params: {
                                gene1,
                                checkedMutationTypesStr,
                            },
                            method: 'get',
                        }).then((res)=>{
                            // console.log(res.data)
                            this.accessionsList = res.data;
                            this.show_result1 = 1;
                            this.isWaiting = 0;
                            const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                            scrollAnimation(currentY, 300)
                        })
                    } else {
                        alert('Please input Gene!')
                    }
                } else if (this.radio == 3) {
                    var accession1 = this.accession1;
                    var checkedMutationTypes1 = this.checkedMutationTypes;
                    var checkedMutationTypesStr1 = checkedMutationTypes1.join(';')
                    if (this.accession1 != '') {
                        axios({
                            url: 'http://39.100.233.196:8001/api/search_B9008_MutLibAccessions/',
                            type: 'json',
                            params: {
                                accession1,
                                checkedMutationTypesStr1,
                            },
                            method: 'get',
                        }).then((res)=>{
                            // console.log(res.data)
                            this.accessionMutationList = res.data;
                            this.show_result3 = 1;
                            this.isWaiting = 0;
                            const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                            scrollAnimation(currentY, 300)
                        })
                    }
                } else if (this.radio == 4) {
                    var BrapaGene = this.BrapaGene;
                    axios({
                        url: 'http://39.100.233.196:8001/api/search_B9008_MutLibBrapaGene/',
                        type: 'json',
                        params: {
                            BrapaGene,
                        },
                        method: 'get',
                    }).then((res)=>{
                        console.log(res.data)
                        this.show_result7 = 1;
                        this.BrapaGeneList = res.data;
                        this.isWaiting = 0;
                        const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                        scrollAnimation(currentY, 600)
                    })
                }
            },
            tableRowClassName ({row, rowIndex}) {                            // eslint-disable-line no-unused-vars
                if (rowIndex === 5) {
                    return 'success-row';
                }
                return '';
            },
            exportAccessionsExcel() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#accessionsShow").removeChild(fix))
                    document.querySelector("#accessionsShow").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#accessionsShow"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "Accessions.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
            exportMutationsExcel() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#mutationsShow").removeChild(fix))
                    document.querySelector("#mutationsShow").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#mutationsShow"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "Mutations.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
            exportAccessionMutationsExcel() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#accessionMutationShow").removeChild(fix))
                    document.querySelector("#accessionMutationShow").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#accessionMutationShow"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "Mutations.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
            exportAccessionsExcel1() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#accessionsShow1").removeChild(fix))
                    document.querySelector("#accessionsShow1").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#accessionsShow1"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "Accessions.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
            exportAccessionsExcel2() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#accessionsShow2").removeChild(fix))
                    document.querySelector("#accessionsShow2").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#accessionsShow2"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "Accessions.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
            exportMutationsExcel1() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#mutationsShow1").removeChild(fix))
                    document.querySelector("#mutationsShow1").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#mutationsShow1"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "Mutations.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
            exportMutationsExcel2() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#mutationsShow2").removeChild(fix))
                    document.querySelector("#mutationsShow2").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#mutationsShow2"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "Mutations.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
            exportAthGeneExcel() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#AthGeneShow").removeChild(fix))
                    document.querySelector("#AthGeneShow").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#AthGeneShow"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "A. thaliana_best_hit.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
            exportBrapaGeneExcel() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#BrapaGeneShow").removeChild(fix))
                    document.querySelector("#BrapaGeneShow").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#BrapaGeneShow"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        "B. rapa Chiifu syntenic genes.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
        },
        watch: {
            'AthGene': {
                handler: function(val) {
                    if (val != '') {
                        this.isDescription = true
                    } else {
                        this.isDescription = false
                    }
                }
            },
            'description': {
                handler: function(val) {
                    if (val != '') {
                        this.isAthGene = true
                    } else {
                        this.isAthGene = false
                    }
                }
            },
            'radio': {
                handler() {
                    this.show_result1 = 0;
                    this.show_result2 = 0;
                    this.show_result3 = 0;
                    this.show_result4 = 0;
                    this.show_result5 = 0;
                    this.show_result6 = 0;
                    this.show_result7 = 0;
                    this.show_result8 = 0;
                    this.show_result9 = 0;
                }
            }
        },
    }
</script>

<style>

    /* #MutLibGeneSearch-div {
        height: 1000px;
    } */

    #MutLibGeneSearch-div .region_select1 {
        height: 45px;
        width: 800px;
        margin: 10px auto 30px 210px;
        /* border: 1px solid #000; */
    }

    #MutLibGeneSearch-div .el-form-item__label {
        color: #407338;
    }

    #MutLibGeneSearch-div .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
    }

    #MutLibGeneSearch-div .el-button:hover {
        background-color: #E5F1FB;
        color: black;
    }

    #MutLibGeneSearch-div .information_input {
        width: 850px;
        margin: auto;
        /* border: 1px solid #000; */
    }

    #MutLibGeneSearch-div .mutation_type_select1 {
        width: 760px;
        margin: -20px auto 15px auto;
        /* border: 1px solid #000; */
    }

    #MutLibGeneSearch-div .mutation_type_select1 .el-transfer-panel {
        width: 320px;
        text-align: left;
        height: 255px;
    }

    #MutLibGeneSearch-div .mutation_type_select1 .el-transfer-panel__list{
        padding: 6px 0;
        height:213px;
        overflow: auto;
        list-style: none;
    }

    #MutLibGeneSearch-div .mutation_type_select1 .el-transfer-panel__item {
        height: 26px;
        line-height: 26px;
    }

    #MutLibGeneSearch-div .mutation_type_select1 .el-transfer-panel__item.el-checkbox {
        color:#407338;
        font-size: 15px;
    }

    #MutLibGeneSearch-div .mutation_type_select1 .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
        color:#407338;
        font-size: 16px;
        font-weight: bold;
    }

    #MutLibGeneSearch-div .mutation_type_select1 .el-transfer__buttons {
        display: inline-block;
        vertical-align: middle;
        padding: 0 10px;
    }

    .region_select1 .el-radio__input.is-checked .el-radio__inner {
        border-color: #407338;
        background: #407338;
    }

    .region_select1 .el-radio.is-bordered.is-checked {
        border-color: #407338;
    }

    .region_select1 .el-radio__input.is-checked + .el-radio__label {
        color: #407338;
    }

    .region_select1 .el-radio.is-bordered {
        border: 2px solid #95a5a6;
    }

    .region_select1 .el-radio {
        font-weight: 800;
    }

    #MutLibGeneSearch-div .show_result1 {
        margin: 10px auto auto 0;
        height: 360px;
        float: left;
        width: 338px;
        /* border: 1px solid #000; */
    }

    #MutLibGeneSearch-div .show_result2 {
        margin: 10px 0 auto auto;
        height: 360px;
        float: right;
        width: 770px;
        /* border: 1px solid #000; */
    }

    #MutLibGeneSearch-div .show_result3 {
        margin: 10px auto auto auto;
        height: 360px;
        /* float: left; */
        width: 1140px;
        /* border: 1px solid #000; */
    }

    #MutLibGeneSearch-div .show_result4 {
        margin: 10px auto auto auto;
        height: 420px;
        width: 1140px;
    }

    #MutLibGeneSearch-div .show_result5 {
        margin: 10px auto auto 0;
        height: 360px;
        float: left;
        width: 338px;
        /* border: 1px solid #000; */
    }

    .el-table .success-row {
      background: #c3faa5;
    }

    #waiting {
        text-align: center;
        position: fixed;
        width: 200px;
        height: 200px;
        /*background: rgba(119, 176, 127, 0.35);*/
        left: 0;
        right: 0;
        top: 35%;
        margin: 0 auto;
    }

    .hr1 {
        border: 1px solid #407338
    }
</style>
